<template>
  <v-list>
    <a :href="item.uri" v-for="(item, key) in items" :key="key">
      <v-card class="ma-1" tile v-if="item">
        <v-list-item v-if="type === 0">
          <v-list-item-icon>
            <v-img :src="item.album.images[0].url" width="128" height="128"/>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> {{item.name}} </v-list-item-title>
            <v-list-item-subtitle> 
              <span v-for="(artist, i) in item.artists" :key="i">
                {{ artist.name }}<span v-if="i !== item.artists.length - 1">, </span>
              </span>  
            </v-list-item-subtitle> 
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="type === 1">
          <v-list-item-icon>
            <v-img :src="item.images[2].url" width="128" height="128"/>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> {{item.name}} </v-list-item-title>
            <v-list-item-subtitle> 
              <span v-for="(genre, i) in item.genres" :key="i">
                {{ genre }}<span v-if="i !== item.genres.length - 1">, </span>
              </span>
            </v-list-item-subtitle> 
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="type === 2">
          <v-list-item-icon>
            <v-img :src="item.images[0].url" width="128" height="128"/>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> {{item.name}} </v-list-item-title>
            <v-list-item-subtitle> 
              <span v-for="(artist, i) in item.artists" :key="i">
                {{ artist.name }}<span v-if="i !== item.artists.length - 1">, </span>
              </span>  
            </v-list-item-subtitle> 
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </a>
  </v-list>
</template>

<style>
  a {
    text-decoration: none;
  }
</style>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    type: {
      type: Number,
      required: true
    }
  }
}
</script>
